import gql from 'graphql-tag';

export default gql`
  fragment mailCampaignMailSendProspectActivityFragment on MailCampaignMailSendProspectActivity {
    id
    hubspotEmailIdString
    hubspotContactIdString
    mailCampaignSend {
      id
      bodyHtml
      subject
      to
      createdAt
      mailCampaign {
        id
        uuid
        title
        fromAddress
        fromName
        cc
        bcc
        sendAt
        isImmediately
        bodyHtml
        pool {
          uuid
        }
      }
    }
  }
`;
